export default __webpack_public_path__ + "static/media/task3refresh.8d825beb.gif";